import React from 'react'
import { redirectToCore } from '@helpers'
import { Button } from '../../UI'
import ClassroomMessage from './ClassroomMessage'

const AdmissionRejected = () => {
  const goToDash = () => {
    redirectToCore(`/`)
  }

  return (
    <div className='gp-ClassroomOnboarding'>
      <ClassroomMessage
        emoji='🔒'
        title='Your admission to the classroom has been rejected'
        description='If there was a mistake, please contact your tutor or customer support to request admission again.'
      />

      <Button
        className='gp-ClassroomMessage-actionButton'
        theme='c interactive'
        events={{ onClick: goToDash }}
        inverted
        icon={{
          name: 'arrow right long',
          value: 'Back to dashboard',
          group: 'a3'
        }}
      />
    </div>
  )
}

export default AdmissionRejected
